import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import MasterDetailLayout from './MasterDetailLayout'
import Header from 'components/Header'
import AddButton from 'components/AddButton'
import Hamburger from 'components/Hamburger'
import PropertiesTable from './Table'
import Details from './Details'
import PropertyForm from './propertyForm'
import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert"
import Avatar from 'material-ui/Avatar'
import RaisedButton from 'material-ui/RaisedButton'

import Notifications from './Notifications'
import ManagerContacts from './ManagerContacts'
import { owners } from 'selectors/entities'
import { propertiesTable } from 'selectors/propertiesTable'
import { currentUser } from 'selectors/common'

import dataActions from 'actions/dataActions'
import sessionActions from 'actions/sessionActions'
import financeActions from 'actions/financeActions'
import tooltipsActions from 'actions/tooltipsActions'
import moment from 'moment'
import { Link } from 'react-router'

let select = (state, props) => ({
	properties: propertiesTable(state)
  , currentUser: currentUser(state)
  , owners: owners(state)
  , selectedProperty: state.selectedProperty
})

export class Dashboard extends Component {
	state = { isOpen: false }
	toggleMenu = () => {
			this.setState({
				isOpen: !this.state.isOpen
			})
		}
	render() {
		let { props } = this
		let detailID = props.selectedProperty
		let amontProperty = props.properties && R.keys(props.properties).length
		if (amontProperty==1){
			detailID=R.keys(props.properties)[0]
		}
		let selectedProperty = R.keys(props.properties)[0]
		let header = (style) => (
			<header style={{
					width:"100%"
					, padding: "5px"
					, boxSizing: "borderBox"
					, height: "60px"
					, backgroundColor: "#009688"
					, textAlign: "left"
			}}>
				<div className="left-side" style={{float: 'left'}}>
					<div className="logo-container" style={{display:"inline-block", float: 'none', verticalAlign: 'middle', height: "100%"}}>
						<a href="/">
							<img width="125" height="40" src="/landlord/static/img/lumand-logo-ll.png" alt="logo" />
						</a>
					</div>
					<div className="manager-contact-container" style={{display:"inline-block", float: 'none', margin: "0 15px 0 30px", verticalAlign: 'middle'}}>
						<ManagerContacts />
					</div>
					<div className="notifications-container" style={{display:"inline-block", float: 'none', verticalAlign: 'middle'}}>
						<Notifications objectID="all"/>
					</div>
				</div>
				<div className="right-side" style={{float: 'right'}}>
					<div className="report-container" style={{display:"inline-block", float: 'left', verticalAlign: 'middle', marginTop: "7px"}}>
						<Link
							to={`/landlord/finances`}
							onClick={() => props.SET_PROPERTY(props.propertyID)}
							title="Reports"
						>
							<RaisedButton
								label="Reports"
								backgroundColor="#4cb6ac"
								labelColor="#FFF"
								style={{backgroundColor: "none"}}
								icon={<i className="material-icons" style={{color: "#FFF"}}>assignment</i>}
							/>
						</Link>
					</div>
					<div className="user-menu-container" style={{display:"inline-block", margin: "0 25px"}}>
						<span style={{lineHeight:"50px", fontSize:"18px", float:"left", color: "white", cursor: "pointer"}} onClick={()=>{this.toggleMenu()}}>
							{props.owners[props.currentUser] && (props.owners[props.currentUser].firstName || props.owners[props.currentUser].name || "") }
						</span>
						<IconMenu
							iconButtonElement={<IconButton style={{padding:"0", height:"40px", width:"40px", top:"5px",color: "white"}}><i className="material-icons" style={{color: "white"}}>keyboard_arrow_down</i></IconButton>}

							anchorOrigin={{horizontal: 'left', vertical: 'top'}}
							targetOrigin={{horizontal: 'left', vertical: 'top'}}
							open={this.state.isOpen}
							onRequestChange={this.toggleMenu}
							onItemTouchTap={(event, obj)=>obj.props.act()}
							style={{
								verticalAlign: "middle"
								, padding:"0"
							}}
						>
							<Link
								to={'/landlord/profile/'+props.currentUser}
								style={{textDecoration: "none"}}
							>
							<MenuItem
								value="Profile"
								primaryText="Profile"
							/>
							</Link>
							<MenuItem
								value="Log out"
								primaryText="Log out"
								act={() => props.LOGOUT()}
							/>
						</IconMenu>
					</div>
				</div>
			</header>
		)
		return(
			<div onClick={props.CLOSE_ALL_TOOLTIPS}>
			<MasterDetailLayout
				header={header}
				master={props => (amontProperty > 1)
					?<PropertiesTable {...props} detailID={detailID} />
					:<PropertyForm id={selectedProperty} leftOnly={true}/>
				}
				detail={props => <Details {...props} detailID={detailID} oneProperty={amontProperty === 1}/>}
				detailColumns={2}
				detailOpen={true}
			/>
			</div>
		)
	}
}

export default connect(select, {...dataActions, ...sessionActions, ...financeActions, ...tooltipsActions})(Dashboard)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/index.js